import { useAnimateOnView } from 'customHooks/useAnimateOnView';
import useTranslation from 'customHooks/translate';

import { fadeInUp } from './landing-motion';

const Footer = () => {
  const translation = useTranslation();
  const { ref, visible } = useAnimateOnView();

  return (
    <footer
      ref={ref}
      className={`flex flex-wrap items-center justify-center gap-[12px] px-[16px] py-[20px] md:justify-between md:px-[112px] md:py-[40px] ${
        visible ? fadeInUp : 'opacity-0'
      }`}
    >
      <span className="text-center leading-[16px] text-[rgba(41,45,50,1)] opacity-70">
        <a href="mailto:sales@invoice-reporter.com">
          sales@invoice-reporter.com
        </a>
      </span>
      <span className="flex flex-col gap-[4px] text-center leading-[16px] text-[rgba(41,45,50,1)] opacity-70">
        <span>
          © {new Date().getFullYear()} {translation.home.Footer.DigeraName} |{' '}
          {translation.home.Footer.AllRights}
        </span>
        <span>{translation.info.tin} : 2007374731</span>
      </span>
    </footer>
  );
};

export default Footer;
